import { createContext, ReactNode, useContext, useState } from 'react';
import { ClientToken } from 'src/types/client';

import { dismissAllNotifications } from './notifications';

export interface AuthContextType {
  clientId: string | null;
  onLogin: (data: ClientToken) => void;
  onLogout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  clientId: null,
  onLogin: () => undefined,
  onLogout: () => undefined,
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [clientId, setClientId] = useState(
    () => localStorage.getItem('clientId') || null
  );

  const onLogin = (data: ClientToken) => {
    localStorage.setItem('authToken', data.authToken);
    localStorage.setItem('clientId', JSON.stringify(data.clientId));
    setClientId(JSON.stringify(data.clientId));
    dismissAllNotifications();
  };

  const onLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('clientId');
    setClientId(null);
  };

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <AuthContext.Provider value={{ clientId, onLogin, onLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
